import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "../components/Reveal";
import { IMG } from "../lib/scenes";

// Close — the day ends, ready for tomorrow. Melts into the canvas on both edges.
export const SceneClose = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scale = useTransform(scrollYProgress, [0, 1], [1.1, 1]);

  return (
    <section
      id="close"
      data-scene
      ref={ref}
      className="relative flex min-h-[72vh] items-center overflow-hidden"
    >
      <motion.img
        src={IMG.close}
        alt="A calm dining room at the end of the evening"
        style={{ scale, filter: "brightness(1.18) contrast(1.02)" }}
        className="absolute inset-0 h-full w-full object-cover"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#141210]/72 via-[#141210]/28 to-transparent" />
      <div className="absolute inset-x-0 top-0 h-28 bg-gradient-to-b from-[#f5f2ea] to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-[#f5f2ea] to-transparent" />

      <div className="relative mx-auto w-full max-w-[1600px] px-6 md:px-12 lg:px-24">
        <span className="font-body text-[11px] uppercase tracking-[0.32em] text-[#EA6A43]">
          The day ends
        </span>
        <h2 className="mt-6 max-w-4xl font-display text-6xl font-black leading-[0.9] tracking-tighter text-white sm:text-7xl">
          <Reveal as="span">Ready for tomorrow.</Reveal>
        </h2>
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-15%" }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
          className="mt-6 max-w-md font-body text-xl text-white/85"
        >
          Everything closed. Nothing forgotten.
        </motion.p>
      </div>
    </section>
  );
};
